import React from 'react';
import type { EmployeePhotoProps } from '../types';
import { resolvePhotoUrl } from '../services/api';

const EmployeePhoto: React.FC<EmployeePhotoProps> = ({ photoURL, name, size = 'large' }) => {
  /* Responsive: large and xlarge photos scale down on mobile to prevent overflow */
  const sizeClasses: Record<NonNullable<EmployeePhotoProps['size']>, string> = {
    tiny: 'w-6 h-6 text-[10px]',
    small: 'w-10 h-10 text-sm',
    medium: 'w-12 h-12 text-base',
    large: 'w-20 h-20 sm:w-32 sm:h-32 text-2xl sm:text-4xl',
    xlarge: 'w-28 h-28 sm:w-40 sm:h-40 text-3xl sm:text-5xl'
  };

  const resolvedUrl = resolvePhotoUrl(photoURL);
  const hasImage = !!resolvedUrl;

  return (
    <>
      {hasImage ? (
        <img
          src={resolvedUrl}
          alt={name}
          className={`${sizeClasses[size]} rounded-full object-cover shadow-lg`}
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.style.display = 'none';
            const nextSibling = target.nextSibling as HTMLDivElement;
            if (nextSibling) {
              nextSibling.style.display = 'flex';
            }
          }}
        />
      ) : null}
      <div
        className={`${sizeClasses[size]} rounded-full bg-gradient-to-br from-blue-500 via-purple-500 to-pink-500 flex items-center justify-center text-white font-bold flex-shrink-0 shadow-lg`}
        style={{ display: hasImage ? 'none' : 'flex' }}
      >
        {name?.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2) || '?'}
      </div>
    </>
  );
};

export default EmployeePhoto;
